import { Routes } from '@angular/router';
import {LoginComponent} from './components/login/login.component';
import {defaultAuthGuardGuard} from './components/shared/guard/default-auth-guard.guard';
import {HomeComponent} from './components/home/home.component';
import {DocumentoComponent} from './components/documento/documento.component';
import {PerfilComponent} from './components/perfil/perfil.component';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'index', component: HomeComponent, canActivate: [defaultAuthGuardGuard] },
  {path: 'meus-documentos', component: DocumentoComponent, canActivate: [defaultAuthGuardGuard]},
  {path: 'perfil', component: PerfilComponent, canActivate: [defaultAuthGuardGuard]},
];
